import { action, makeObservable, observable, runInAction } from 'mobx';
import { type DispensaryResDto } from '@web/common';
import { getUserDispensary } from '../../../../../../request/authenticated-requests/dispensary';
import { handleRequestError } from '../../../../../../request';
import { setupMobX } from '../../../../../../util/setupMobX';

export class PickUpStore {
  @observable public loading: boolean = false;
  @observable public dispensary: null | DispensaryResDto = null;

  constructor() {
    makeObservable(this);
  }

  @action public getUserDispensary(userId: string) {
    // Two components ask for the dispensary at the same time. Skip the call
    // if one is already in flight.
    if (this.loading) return;
    this.loading = true;

    getUserDispensary(userId)
      .then((dispensary) => runInAction(() => (this.dispensary = dispensary)))
      .catch((error) => handleRequestError(error))
      .finally(() => runInAction(() => (this.loading = false)));
  }
}

const { provider, useStore } = setupMobX<PickUpStore>();
export const usePickUpStore = useStore;
export const PickUpStoreProvider = provider;
